"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryBuilderPluginConfigurator = exports.SelectQueryBuilder2 = void 0;
const core_1 = require("@material-ui/core");
const react_1 = __importStar(require("react"));
const react_2 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const QueryBuilderPluginPicker_1 = __importDefault(require("../pickers/QueryBuilderPluginPicker"));
const entity_ui_1 = require("@sierralabs/entity-ui");
const QueryBuilderPluginConditionPicker_1 = __importDefault(require("../pickers/QueryBuilderPluginConditionPicker"));
const ColumnsSelector_1 = __importDefault(require("../selectors/ColumnsSelector"));
const StyledDiv = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  height: fit-content;
  .predicate {
    padding-bottom: 5px;
  }
  .filter {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .keyword {
    padding: 4px 2px;
    margin-bottom: 6px;
  }
  .or-divider {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 6px 0 8px 0;
    .label {
      padding: 4px 6px;
      /* background: #fff; */
      /* border: 1px solid #ccc; */
      /* border-radius: 10px; */
      color: ${p => p.theme.palette.primary.main};
      font-size: 12px;
    }
    &::after {
      content: '';
      display: block;
      flex: 1 1 auto;
      border-top: 1px dotted #ccc;
      height: 1px;
    }
  }
  .card-overline {
    margin: 24px 4px 0 4px;
  }
  .and-divider {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0;
    width: 54px;
    /* &::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: calc(50% - 1px);
      width: 1px;
      height: 100%;
      border-left: 1px dotted #ccc;
    } */
    .chip {
      color: #999;
      font-size: 12px;
      padding: 8px 16px;
      border-radius: 18px;
      background: ${p => p.theme.palette.primary.main};
      color: #fff;
      z-index: 1;
      /* border: 1px solid #ccc; */
    }
  }
  .add-button-container {
    margin-top: 24px;
  }
`;
const SelectQueryBuilder2 = (_a) => {
    var _b, _c, _d, _e, _f, _g, _h;
    var { plugins = [], className, hideAdvanced, onChange, onSetQueryManager } = _a, props = __rest(_a, ["plugins", "className", "hideAdvanced", "onChange", "onSetQueryManager"]);
    const onChangeRef = (0, react_2.useRef)(onChange);
    onChangeRef.current = onChange;
    const onSetQueryManagerRef = (0, react_2.useRef)(onSetQueryManager);
    onSetQueryManagerRef.current = onSetQueryManager;
    const mountRef = (0, react_2.useRef)(false);
    const queryBuilderRef = (0, react_2.useRef)();
    if (plugins.length === 0)
        plugins = ((_b = queryBuilderRef.current) === null || _b === void 0 ? void 0 : _b.plugins) || [];
    const [query, setQuery] = (0, react_1.useState)(props.query);
    const [queryManager, setQueryManager] = (0, react_1.useState)((_c = queryBuilderRef.current) === null || _c === void 0 ? void 0 : _c.queryManager);
    // listen for query changes and update state
    (0, react_1.useEffect)(() => {
        var _a;
        // set QueryManagerRef to make it accessible outside the component
        (_a = onSetQueryManagerRef.current) === null || _a === void 0 ? void 0 : _a.call(onSetQueryManagerRef, queryManager);
        if (!queryManager)
            return;
        const handleChange = () => {
            var _a;
            setQuery(Object.assign({}, queryManager.query));
            // don't notify on initial load
            if (mountRef.current) {
                (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, queryManager.query);
            }
            mountRef.current = true;
        };
        handleChange();
        queryManager.subscribe('change', handleChange);
        return () => {
            queryManager.unsubscribe('change', handleChange);
        };
        // refresh queryManager when reference is updated
    }, [queryManager]);
    // get selected query plugins for the query configuration
    const selectedPlugins = (0, react_1.useMemo)(() => {
        var _a, _b;
        if (!query || !((_a = query === null || query === void 0 ? void 0 : query.config) === null || _a === void 0 ? void 0 : _a.pluginConfigs))
            return [];
        const selectedPlugins = [];
        for (const config of ((_b = query === null || query === void 0 ? void 0 : query.config) === null || _b === void 0 ? void 0 : _b.pluginConfigs) || []) {
            const plugin = plugins.find(p => p.type === config.type);
            if (!plugin)
                continue;
            selectedPlugins.push({ plugin, config });
        }
        return selectedPlugins;
    }, [plugins, query]); // explicitly watch for query changes
    const classes = ['select-query-builder-2'];
    if (className)
        classes.push(className);
    const pluginConditions = ((_d = query === null || query === void 0 ? void 0 : query.config) === null || _d === void 0 ? void 0 : _d.pluginConditions) || [];
    return (react_1.default.createElement(QueryBuilderContext_1.QueryBuilderProvider, { ref: context => {
            var _a;
            queryBuilderRef.current = context;
            setQueryManager((_a = queryBuilderRef.current) === null || _a === void 0 ? void 0 : _a.queryManager);
        }, query: query, plugins: plugins },
        react_1.default.createElement(StyledDiv, Object.assign({ className: classes.join(' ') }, props),
            !hideAdvanced && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Typography, { variant: 'overline', className: 'card-overline' }, "Entity"),
                react_1.default.createElement(core_1.Card, { className: 'from-entity' },
                    react_1.default.createElement(core_1.CardContent, null,
                        react_1.default.createElement(entity_ui_1.EntityPicker, { value: (_f = (_e = query === null || query === void 0 ? void 0 : query.config) === null || _e === void 0 ? void 0 : _e.mainAlias) === null || _f === void 0 ? void 0 : _f.tablePath, onChange: entity => {
                                if (!entity)
                                    return;
                                queryManager === null || queryManager === void 0 ? void 0 : queryManager.updateFrom(entity);
                            } }))),
                react_1.default.createElement(core_1.Typography, { variant: 'overline', className: 'card-overline' }, "Data Sets"),
                react_1.default.createElement(core_1.Card, { className: 'data-sets' },
                    react_1.default.createElement(core_1.CardContent, null,
                        react_1.default.createElement(core_1.List, null, selectedPlugins.map((selected, index) => (react_1.default.createElement(core_1.ListItem, { key: selected.plugin.type },
                            react_1.default.createElement(core_1.ListItemText, { primary: selected.plugin.name }),
                            react_1.default.createElement(core_1.ListItemSecondaryAction, null,
                                react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: () => {
                                        queryManager === null || queryManager === void 0 ? void 0 : queryManager.deletePluginConfig(index);
                                    } },
                                    react_1.default.createElement(core_1.Icon, null, "close"))))))),
                        react_1.default.createElement(QueryBuilderPluginPicker_1.default, { placeholder: 'Add a data set', onChange: plugin => {
                                if (!plugin)
                                    return;
                                queryManager === null || queryManager === void 0 ? void 0 : queryManager.addPluginConfig({
                                    type: plugin.type,
                                    params: {}
                                });
                            } }))),
                selectedPlugins
                    .filter(s => s.plugin.component)
                    .map((selected, index) => {
                    return (react_1.default.createElement(react_1.Fragment, { key: index },
                        react_1.default.createElement(core_1.Typography, { variant: 'overline', className: `card-overline plugin-${index}` }, selected.plugin.name),
                        react_1.default.createElement(core_1.Card, { className: `card plugin-${index}` },
                            react_1.default.createElement(core_1.CardContent, null, selected.plugin.component && (react_1.default.createElement(selected.plugin.component, Object.assign({}, selected.config)))))));
                }))),
            react_1.default.createElement(core_1.Typography, { variant: 'overline', className: 'card-overline' }, "Fields"),
            react_1.default.createElement(core_1.Card, { className: 'fields' },
                react_1.default.createElement(core_1.CardContent, null,
                    react_1.default.createElement(ColumnsSelector_1.default, { multiple: true, vertical: true, value: ((_h = (_g = query === null || query === void 0 ? void 0 : query.config) === null || _g === void 0 ? void 0 : _g.selects) === null || _h === void 0 ? void 0 : _h.map(s => s.selection)) || [], onColumnChange: (selection, index, columnMap) => {
                            const select = { selection };
                            if (columnMap === null || columnMap === void 0 ? void 0 : columnMap.plugin) {
                                select.pluginType = columnMap.plugin.type;
                            }
                            queryManager === null || queryManager === void 0 ? void 0 : queryManager.updateSelect(index, select);
                            console.log('ColumnSelector onChange', columnMap, selection, index);
                        }, onMove: (sourceIndex, targetIndex) => queryManager === null || queryManager === void 0 ? void 0 : queryManager.moveSelect(sourceIndex, targetIndex), onDelete: index => queryManager === null || queryManager === void 0 ? void 0 : queryManager.deleteSelect(index) }))),
            react_1.default.createElement(core_1.Typography, { variant: 'overline', className: 'card-overline' }, "Condition"),
            react_1.default.createElement(react_1.Fragment, { key: pluginConditions.length }, pluginConditions.map((orPluginConfigs, andIndex) => {
                const isLast = andIndex === pluginConditions.length - 1;
                return (react_1.default.createElement(react_1.Fragment, { key: andIndex },
                    react_1.default.createElement(core_1.Card, { className: 'query-builder-plugin-card' },
                        react_1.default.createElement(core_1.CardContent, { key: orPluginConfigs.length }, orPluginConfigs.map((pluginConfig, orIndex) => {
                            // console.log('pluginConfig', pluginConfig);
                            const plugin = plugins.find(p => p.type === pluginConfig.pluginType);
                            const isLast = orIndex === orPluginConfigs.length - 1;
                            return (react_1.default.createElement(react_1.Fragment, { key: orIndex },
                                react_1.default.createElement(exports.QueryBuilderPluginConfigurator, { andIndex: andIndex, orIndex: orIndex, plugin: plugin, config: pluginConfig, disableOrButton: !isLast, onDelete: () => queryManager === null || queryManager === void 0 ? void 0 : queryManager.deletePluginCondition(andIndex, orIndex), onAddOrCondition: () => queryManager === null || queryManager === void 0 ? void 0 : queryManager.addOrPluginCondition(andIndex, {
                                        pluginType: '',
                                        conditionType: ''
                                    }) }),
                                !isLast && (react_1.default.createElement("div", { className: 'or-divider' },
                                    react_1.default.createElement("span", { className: 'label' }, "OR")))));
                        }))),
                    !isLast && (
                    // <div className='and-divider'>
                    //   <span className='chip'>AND</span>
                    // </div>
                    react_1.default.createElement(core_1.Typography, { variant: 'overline', className: 'card-overline' }, "AND"))));
            })),
            react_1.default.createElement("div", { className: 'add-button-container' },
                react_1.default.createElement(core_1.Button, { variant: 'contained', color: 'primary', startIcon: react_1.default.createElement(core_1.Icon, null, "add"), onClick: () => {
                        queryManager === null || queryManager === void 0 ? void 0 : queryManager.addAndPluginCondition({
                            pluginType: '',
                            conditionType: ''
                        });
                    } }, "And")))));
};
exports.SelectQueryBuilder2 = SelectQueryBuilder2;
const StyledTable = styled_components_1.default.table `
  width: 100%;
  .configuration-column {
    width: 100%;
  }
  .secondary-actions {
    padding-left: 12px;
    text-align: right;
    min-width: 52px;
    &.or-container {
      vertical-align: bottom;
    }
    .or-button {
      min-width: 32px;
    }
  }
  td {
    padding: 4px 0;
  }
`;
const QueryBuilderPluginConfigurator = ({ andIndex, orIndex, plugin, config = {}, disableOrButton, onDelete, onAddOrCondition }) => {
    var _a;
    const { queryManager } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    const [condition, setCondition] = (0, react_1.useState)((_a = plugin === null || plugin === void 0 ? void 0 : plugin.conditions) === null || _a === void 0 ? void 0 : _a.find(c => c.type === (config === null || config === void 0 ? void 0 : config.conditionType)));
    return (react_1.default.createElement(StyledTable, { className: 'plugin-configurator' },
        react_1.default.createElement("tbody", null,
            react_1.default.createElement("tr", null,
                react_1.default.createElement("td", { className: 'configuration-column' },
                    react_1.default.createElement(QueryBuilderPluginConditionPicker_1.default, { value: config === null || config === void 0 ? void 0 : config.conditionType, onChange: condition => {
                            setCondition(condition);
                        } })),
                react_1.default.createElement("td", { className: 'secondary-actions' },
                    react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: () => {
                            onDelete === null || onDelete === void 0 ? void 0 : onDelete(config);
                        } },
                        react_1.default.createElement(core_1.Icon, null, "close")))),
            react_1.default.createElement("tr", null,
                react_1.default.createElement("td", null, condition && (react_1.default.createElement(condition.component, Object.assign({ andIndex: andIndex, orIndex: orIndex }, config)))),
                react_1.default.createElement("td", { className: 'secondary-actions or-container' }, !disableOrButton && (react_1.default.createElement(core_1.Button, { variant: 'outlined', color: 'primary', size: 'small', className: 'or-button', onClick: () => {
                        onAddOrCondition === null || onAddOrCondition === void 0 ? void 0 : onAddOrCondition(config);
                    } }, "OR")))))));
};
exports.QueryBuilderPluginConfigurator = QueryBuilderPluginConfigurator;
//# sourceMappingURL=SelectQueryBuilder2.js.map